import React from 'react';
import PropTypes from 'prop-types';
import { styled } from 'twin.macro';

import { ConverseMessage } from '@sopranodesign/pulse-volt';

const Wrapper = styled.div`
  & > div > * {
    max-width: 100%;
  }
`;

const ResponsePreview = ({ type = 'dynamic', content, language }) => {
  const message = {
    id: null,
    type,
    content,
    direction: 'toClient',
    language: language
  };

  return (
    <Wrapper>
      <ConverseMessage
        message={message}
        groups={[[message]]}
        groupIndex={0}
        handleButtonClick={() => { }}
        handleButtonLocationClick={() => { }}
      />
    </Wrapper>
  );
};

ResponsePreview.propTypes = {
  language: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
  content: PropTypes.object
};

export default ResponsePreview;
